<template>
  <div>
    <div class="spinner">
      <b-spinner variant="primary" label="Spinning" large></b-spinner>
      <h3 class="mt-4" v-if="message.length > 0">{{ message }}</h3>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

export default {
  components: {
    BSpinner
  },
  props: {
    message: String
  }
};
</script>

<style>
/* The spinner shows up briefly before the CSS is loaded and it looks weird, so added the styles here to make up for that */
.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 10% 0;
  background-color: transparent;
}

.spinner-overlay .spinner {
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.9);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 200;
  margin-top: 0;
}

.spinner .spinner-border {
  height: 36px;
  width: 36px;
}
</style>
